// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-create-new-js": () => import("./../../../src/pages/CreateNew.js" /* webpackChunkName: "component---src-pages-create-new-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-lolly-template-tsx": () => import("./../../../src/templates/LollyTemplate.tsx" /* webpackChunkName: "component---src-templates-lolly-template-tsx" */)
}

